export const MuiTableHead = {
  styleOverrides: {
    root: {
      borderBottom: '2px solid rgba(84, 110, 122, .5)',
      width: '30%',
    },
  },
};
